<form (submit)="onSubmit()" [formGroup]="form">
  <div class="flex flex-col gap-4 pt-4">
    @for (question of questions; track question) {

      @if(question.key !== 'appointment'){
        <afcu-input [form]="form" [question]="question"/>
      } @else if (Settings.GLOBAL.notifications_all_text_enabled) {
        <afcu-input [form]="form" [question]="question"/>
      }
      
    }

    <div class="text-sm w-full flex flex-col gap-4" [innerHTML]="getText().contactInfo.legal">
    </div>

    @if (isError){
      <afcu-banner state="error" [content]="getText().contactInfo.banner.error"/>
    }

    <button
      class="w-full md:w-fit lg:w-fit py-3.5 bg-afcu-navy-800 px-6 font-semibold text-white rounded flex"
      type="submit"
      tabindex="7"
      [disabled]="form.valid && isSubmitted && !errorAppointmentCompletion"
      [class.cursor-not-allowed]="form.valid && isSubmitted && !errorAppointmentCompletion"
      [class.opacity-70]="form.valid && isSubmitted && !errorAppointmentCompletion"
    >
      @if (form.valid && isSubmitted){
        @if (!errorAppointmentCompletion){
          <svg class="mr-3 -ml-1 size-5 animate-spin text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        }
      }
      <p class="pl-[40%] md:pl-0 lg:pl-0">{{getText().contactInfo.form.submit}}</p>
    </button>
  </div>

</form >
